import styled from 'styled-components';

export const CollapsibleComp = styled.div`
    border-radius: 0.4rem;
    background-color: #ffffff;
    margin: ${p => p.margin ? p.margin : ''};
`;
export const CollapsibleCompHeader = styled.div`
    padding: 2.3rem 3rem 2rem 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3{
        font-family: quicksand;
        font-size: 1.8rem;
        line-height: 2.4rem;
        font-weight: 700;
        color: #141823;
    }
`;

export const CardWrap = styled.section`
  margin-top: 1.5rem;
`;

export const Card = styled.section`
  background: white;
  border-radius: 0.4rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
`;

export const TabContent = styled.div`
  transition: all 0.35s;
`;

export const TabLabel = styled.label(
  props => `
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: ${props.infoText? '2rem 2rem 1rem 2rem': '2rem'}
      cursor: pointer;
      align-items: center;
      &::after {
          content: '\\276F';
          width: 2em;
          height: 2em;
          text-align: center;
          transform: rotate(90deg);
          -webkit-transition: all .35s;
          transition: all .35s;
          color: #898b91;
          font-size: 1.2rem;
          padding-top:0.5rem;
          background: #eef4fd;
          border-radius: 50%;
          margin-top: 0.3rem;
      }
      span {
          color: #141823;
          font-size: 2.2rem;
          font-weight: bold;
          font-family:${props.theme.font.fontFamily};
      }
  `,
);

export const HeaderInput = styled.input`
  position: absolute;
  z-index: -1;
  &:checked + ${TabLabel}::after {
    transform: rotate(-90deg);
  }
  &:checked ~ ${TabContent} {
    max-height: fit-content;
  }
`;

export const Info = styled.p`
    margin-top: 0.5rem;
    padding: 0 2rem 1rem 2rem;
    font-size: 1.2rem;
    color: #898b91;
`;

export const Persuasion = styled.span`
    font-size: 1.2rem;
    margin: 0 2rem;
    padding: 1rem 1rem 1rem 1rem;
    border-radius: 4rem;
    background-color: #e9f6ea;
    color: #2bac36;
    }
`;
